import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupplierRoutingModule } from './supplier-routing.module';
import { SupplierComponent } from './supplier.component';
import { ProcurementPackageComponent } from './procurement-package/procurement-package.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatStepperModule } from '@angular/material/stepper';
import { SelectSupplierComponent } from './select-supplier/select-supplier.component';
import { VerifySelectionComponent } from './verify-selection/verify-selection.component';
import { CompletedComponent } from './completed/completed.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DeletionListModule } from '../shared/deletion-list/deletion-list.module';
import { ManageSuppliersComponent } from './manage-suppliers/manage-suppliers.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';

import { UserViewComponent } from './user-view/user-view.component';
import { ScopeViewComponent } from './scope-view/scope-view.component';
import { LineTagScopeComponent } from './line-tag-scope/line-tag-scope.component';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { VendorPillModule } from '../shared/vendor-pill/vendor-pill.module';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  declarations: [
    SupplierComponent,
    ProcurementPackageComponent,
    SelectSupplierComponent,
    VerifySelectionComponent,
    CompletedComponent,
    ManageSuppliersComponent,
    UserViewComponent,
    ScopeViewComponent,
    LineTagScopeComponent,
  ],
  imports: [
    CommonModule,
    SupplierRoutingModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatStepperModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTabsModule,
    MatListModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatIconModule,
    DeletionListModule,
    MatChipsModule,
    MatDialogModule,
    StatusCircleModule,
    VendorPillModule,
    MatTooltipModule,
    MatSortModule,
    UserManualDirective,
    DirectivesModule,
    ButtonModule,
    ConfirmDialogModule,
    DialogModule,
    FloatLabelModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    TableModule,
    AccordionModule,
    CheckboxModule,
    TooltipModule,
  ],
  providers: [ConfirmationService],
})
export class SupplierModule {}
